module.exports = "<div class=\"left_menu nav\">\n\n  <ul class=\"nav\">\n    <li>\n      <a routerLink=\"/product/list/everything\" routerLinkActive=\"active-link\">Everything</a>\n    </li>\n    <li>\n      <a *ngFor=\"let category of categories\" [routerLink]=\"[category.sys.id]\" routerLinkActive=\"active-link\">{{category.fields.categoryTitle}}</a>\n    </li>\n  </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/productfilter/productfilter.component.html
// module id = ../../../../../src/app/productfilter/productfilter.component.html
// module chunks = main